import { render, staticRenderFns } from "./AdminReadMore.vue?vue&type=template&id=07e2508e"
import script from "./AdminReadMore.vue?vue&type=script&lang=js"
export * from "./AdminReadMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports